import { graphql, useStaticQuery } from "gatsby"

function useDoctorImage() {
  const { image } = useStaticQuery(graphql`
    {
      image: file(
        relativePath: { eq: "rebranded/personalized-product-doctor.png" }
      ) {
        childImageSharp {
          gatsbyImageData(width: 64, layout: FIXED)
        }
      }
    }
  `)

  return { image }
}

export default useDoctorImage
